import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

function Accreditations() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
              <div className='row'>
                  <div className='col-md-3'>
                         <NewIqacSidebar />
                  </div>

                  <div className='col-md-9'>
                    <div className='home'>
                        <div className='about accredition'>
                        <h3>Recognitions and Accreditations </h3>
                            <div className='row'>
                                <div className='col-md-4 col-sm-4 col-xs-12'>
                                    <div className='ranking'>
                                      <div className='img'>
                                        <a href="https://www.ugc.gov.in/universitydetails/Private_university_other?id=633" target='_blank'>
                                        <img src='/assets/img/accredition1.jpg'></img>
                                        <label></label>
                                        </a>
                                      </div>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-4 col-xs-12'>
                                    <div className='ranking'>
                                      <div className='img'>
                                        <a href="/assets/img/accredition2.pdf" target='_blank'>
                                        <img src='/assets/img/accredition2.jpg'></img>
                                        <label>Copy of UGC approval Letter</label>
                                        </a>
                                      </div>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-4 col-xs-12'>
                                    <div className='ranking'>
                                      <div className='img'>
                                        <a href="/assets/img/UGC-Letter-2023.pdf" target='_blank'>
                                        <img src='/assets/img/accredition3.jpg'></img>
                                        <label> Copy of Compliance Letter</label>
                                        </a>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                  </div>


              </div>

         

      </div>

    </>
  )
}

export default Accreditations